<template>

   <div class="inner-video-container">
    <vimeo-player
      v-if="video_url"
      ref="player"
      :video-url="video_url"

      :options="options"
      @ready="onReady"
      @play="handlePlay"
      @pause="handlePause"
      @playing="handlePlaying"
      @cuepoint="handleCuePoints"
      @ended="handleEnded"
      @timeupdate="handleTimeUpdate"
      @progress="handleProgress"
      @seeking="handleSeeking"
      @seeked="handleSeeked"
      @resize="handleResize"
      @error="handleError"
      @loaded="handleLoaded"
      @durationchange="handleDurationChange"
      @fullscreenchange="handleFullscren"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
/**
 * Debounce trailing time: in milliseconds
 * this is 1 second less than the interval time on
 * handleTimeUpdate method
 */
const DEBOUNCE_TRAILING_TIME = 1000

var debounceApiCall = _.debounce(function (params) {
  const config = {
    headers: {
      //Authorization: `Bearer ${process.env.VUE_APP_TOKEN}`,
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json',
      'X-Session-Key': localStorage.getItem('token'),
    },
  }

  var url = process.env.VUE_APP_API_URL + '/api/lmsapp/lessons/progress'
  var data = {
    payload: [params],
  }
  axios
    .post(url, data, config)
    .then((response) => {
      console.log(response, 'response')
    })
    .catch((error) => {
      console.log(error)
    })
}, DEBOUNCE_TRAILING_TIME)

function callLessonProgressApi(params) {
  const config = {
    headers: {
      //Authorization: `Bearer ${process.env.VUE_APP_TOKEN}`,
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json',
      'X-Session-Key': localStorage.getItem('token'),
    },
  }

  var url = process.env.VUE_APP_API_URL + '/api/lmsapp/lessons/progress'
  var data = {
    payload: [params],
  }
  axios
    .post(url, data, config)
    .then((response) => {
      console.log(response, 'response')
    })
    .catch((error) => {
      console.log(error)
    })
}
export default {
  /* eslint-disable */
  name: 'VideoComponent',
  props: {
    height: {
      type: Number,
      required: false,
    },
    active_lesson: {
      type: Object,
      required: true,
    },
    lesson_progress: {
      type: Number,
      default: 0,
    },
    // width: {
    //   type: Number,
    //   required: false,
    //   default: 1280,
    // },
    video_url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      options: {
        //muted: true,
        autoplay: false, // disable autoplay on Chrome
        muted: false,
        responsive: true,
      },
       playerWidth: 0,
      playerHeight: 0,
      aspectRatio: 16 / 9,
      playerReady: false,
      videoUrl: '',
      is_live_event: false,
      is_complete_: false,
      lesson_duration: 0,
      video_id: null,
      timer: null,
      current_time: 0,
      pause: false,
      container_width: null,
      container_height: null,
      last_progress_params: null,
      has_unsaved_progress: false,
    }
  },

  mounted() {
    this.timer = setInterval(() => {
      this.width = this.playerWidth
      this.eventTimer()
    }, 10000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
    if (debounceApiCall && typeof debounceApiCall.cancel === 'function') {
      debounceApiCall.cancel()
    }
    if (this.has_unsaved_progress && this.last_progress_params) {
      callLessonProgressApi(this.last_progress_params)
      this.has_unsaved_progress = false
    }
  },
  created() {
    this.videoUrl = this.video_url
    // this.$store.dispatch("syncProgressState", {});
  },
  methods: {
    isChrome() {

      return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)
    },
    isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  },
    eventTimer() {
      // let video_id = this.video_id
      let time = 10
      let item = {
        current_time: time,
        duration: time,
        course_id: this.course_id,
        video_id: this.video_id,
        lesson_id: this.active_lesson.id,
        type: 'default',
      }
      if (this.is_live_event === true) {
        item.type = 'live_event'
        this.$store.dispatch('updatelessonProgress', item)
      }
    },
    handleResize(event, data) {
      this.$emit('onResize', event)
    },
    handleDurationChange(event, data) {
      console.log(event, data, 'duration change')
    },
    unloadVideo(value) {
      this.$refs.player.player
        .unload()
        .then(function () {
          // the player was destroyed
          // this.loadVideo(value)
        })
        .catch(function (error) {
          // an error occurred
        })
    },
    loadVideo(value) {
      let str = ''
      if (value) {
        str = value
      }
      let video_id = null
      video_id = str.split('m/').pop()
      this.$refs.player.player
        .loadVideo(video_id)
        .then(function (id) {
          // the video successfully loaded
          this.handleReplay()
        })
        .catch(function (error) {
          switch (error.name) {
            case 'TypeError':
              // the id was not a number
              break

            case 'PasswordError':
              // the video is password-protected and the viewer needs to enter the
              // password first
              break

            case 'PrivacyError':
              // the video is password-protected or private
              break

            default:
              // some other error occurred
              break
          }
        })
    },
    handleReplay(value) {
      let current_progress = 0
      this.$refs.player.player
        .setCurrentTime(0)
        .then(function (seconds) {
          // seconds = the actual time that the player seeked to
          this.playerReady = true
        })
        .catch(function (error) {
          switch (error.name) {
            case 'RangeError':
              // the time was less than 0 or greater than the video’s duration
              break

            default:
              // some other error occurred
              break
          }
        })
    },
    handleTimeUpdate(event, data) {
      let progress = event.seconds
      let duration = parseFloat(Number(event.percent * 100).toFixed(2))
      let activeLesson = this.active_lesson
      let params = {
        duration: duration,
        // duration: (event.seconds / this.active_lesson.video.duration) * 100,
        course_id: activeLesson.course_id,
        video_id: activeLesson.video.video_id,
        lesson_id: activeLesson.id,
        chapter_id: activeLesson.chapter_id,
        casesafe_id: localStorage.getItem('customer_id'),
        viewed_at: Math.floor(Date.now() / 1000),
        is_complete: duration > 90 ? 1 : 0,
      }

      // Track latest progress for pause, seek, or unmount without calling backend during playback
      this.last_progress_params = params
      this.has_unsaved_progress = true

      this.$nextTick(() => {
        this.$emit('returnProgress', event.percent, this.active_lesson)
        let params = {
          duration: parseFloat(Number(event.percent * 100).toFixed(2)),
          // duration: (event.seconds / this.active_lesson.video.duration) * 100,
          course_id: activeLesson.course_id,
          video_id: activeLesson.video.video_id,
          lesson_id: activeLesson.id,
          chapter_id: activeLesson.chapter_id,
          casesafe_id: localStorage.getItem('customer_id'),
          viewed_at: Math.floor(Date.now() / 1000),
        }
        this.$store.dispatch('updateLessonProgress', params)
        // this.$store.dispatch('updateLessonProgress', params)
      })

      // if(this.is_complete === false) {
      //   setTimeout(() => {
      //   }, 5000);
      // }
    },
    percentage(num, per) {
      return (num / 100) * per
    },
    handlePlay(event, data, player) {
        // this.lesson_duration = event.duration
        // this.video_duration = event.duration

          const player_new = this.$refs.player;
        player_new.play()
            .then(() => {
              this.playerReady = true;

              this.$emit('stopLoading');
              this.fadeInVolume(player_new, 2000)
            })
            .catch((error) => {
              console.warn("Autoplay blocked:", error);
            });
        if (this.pause === false) {

          this.setCurrentTime(event) // Bug fix for jumping track on resume

        } else {
          this.pause = false
        }


        // const player_new = this.$refs.player.player

        // Make sure volume fade happens only AFTER playback is stable
        // setTimeout(async () => {
        //   try {
        //     const paused = await player_new.getPaused()
        //     if (!paused) {
        //       this.fadeInVolume(player_new, 2000) // fade in over 2s
        //     } else {
        //       console.warn("Video is paused, skipping fade in")
        //     }
        //   } catch (err) {
        //     console.error("Error checking paused state:", err)
        //   }
        // }, 2000) // wait 2s after play starts
      },

    handlePlaying(event, data) {
      // if (event.duration === 0) {
      //   this.is_live_event = true;
      // }
      // setTimeout(() => {
      // }, 5000);
    },
    fadeInVolume(player, duration = 2000) {
      let step = 0.05
      let interval = duration / (1 / step)
      let volume = 0


      if (player && typeof player.setMuted === 'function') {
        player.setMuted(false);
      }

      if (player && typeof player.setVolume === 'function') {
        player.setVolume(1);
      }


      // First unmute safely
      player.setMuted(false).catch(err => {
        console.warn("Unmute failed:", err)
      })

      let fade = setInterval(async () => {
        try {
          const paused = await player.getPaused()
          if (paused) {
            clearInterval(fade)
            return
          }
          volume = Math.min(volume + step, 1)
          player.setVolume(volume)
          if (volume >= 1) clearInterval(fade)
        } catch (err) {
          console.error("Fade volume error:", err)
          clearInterval(fade)
        }
      }, interval)
    },
    onReady(event) {
        // const player = this.$refs.player.player;
        this.playerReady = true;
        this.$emit('stopLoading');
        // if (this.isChrome()) {
        //   // Chrome: do not autoplay
        //   player.setMuted(true);
        //   player.setVolume(1);
        //   console.log("Autoplay disabled on Chrome");
        // } else {
        //   // Other browsers: allow muted autoplay
        //   player.setMuted(true);
        //   player.setVolume(1);

        //   player.play()
        //     .then(() => {
        //       this.playerReady = true;
        //       this.$emit('stopLoading');
        //     })
        //     .catch((error) => {
        //       console.warn("Autoplay blocked:", error);
        //     });
        // }


      // this.$refs.player.player.setVolume(1) //setting volume to 1
      // this.current_time = this.lesson_progress
      // this.$refs.player
      //   .play()
      //   .then(function () {
      //     this.playerReady = true
      //   })
      //   .catch(function (error) {
      //     switch (error.name) {
      //       case 'PasswordError':
      //         // The video is password-protected
      //         break
      //       case 'PrivacyError':
      //         // The video is private
      //         break
      //       default:
      //         // Some other error occurred
      //         break
      //     }
      //   })
      // this.$emit('stopLoading')
    },
    setCuePoints(value) {
      this.$refs.player.player
        .addCuePoint(value, {
          customKey: 'customValue',
        })
        .then(function (id) {
          // cue point was added successfully
        })
        .catch(function (error) {
          switch (error.name) {
            case 'UnsupportedError':
              // cue points are not supported with the current player or browser
              break

            case 'RangeError':
              // the time was less than 0 or greater than the video’s duration
              break

            default:
              // some other error occurred
              break
          }
        })
    },
    handleCuePoints(event, data) {
      let item = {
        current_time: event.time,
        duration: event.duration,
        course_id: this.course_id,
        video_id: this.video_id,
        lesson_id: this.active_lesson.id,
        type: 'default',
      }
      this.$store.dispatch('updatelessonProgress', item)
    },
    setCurrentTime(event) {
      let current_progress = (this.current_time / 100) * event.duration

      console.log(current_progress, 'current_progress')
      // let cur_time = (this.current_time / 100) * event.duration

      this.$refs.player.player
        .setCurrentTime(current_progress)
        .then(function (seconds) {
          console.log(seconds, 'setcurrenttime')
          // seconds = the actual time that the player seeked to
        })
        .catch(function (error) {
          switch (error.name) {
            case 'RangeError':
              // the time was less than 0 or greater than the video’s duration
              break

            default:
              // some other error occurred
              break
          }
        })
    },
    handleFullscren() {},
    setIframeWidth() {
      // Access the iframe inside the div with id="video_container" using plain JavaScript
      const div = document.querySelector('div[id^="vimeo-player-"]');

      // Set the width of the iframe
      // console.log(iframe,'iframe')
      if (div) {
        // Select the iframe inside the div
        const iframe = div.querySelector('iframe');

        // Check if an iframe is found and set its width
        if (iframe) {
          iframe.style.width = this.width + 'px';  // Modify the width as needed
          iframe.style.height = this.height + 'px';
        }
      }
    },
    handleLoaded(event, data) {
      this.video_id = event.id

      let dimension = {
        height: 0,
        width: 0,
      }
      let x = Promise.all([
        this.$refs.player.player.getVideoWidth(),
        this.$refs.player.player.getVideoHeight(),
      ]).then((response) => {
        var width = response[0] >= 960 ? response[0] : 960
        var height = response[1] >= 540 ? response[1] : 540
        console.log(width,'check details')
        this.container_width = width
        this.container_height = height
        this.setIframeWidth()
        dimension = {
          height: height,
          width: width,
        }
        if(this.isChrome() ) {
          this.$emit('loaded', event)
        }

      })
    },

    handleError(event, data) {
      this.$emit('stopLoading')
      if (this.videoUrl.includes('event')) {
      } else {
        this.$emit('failed')
      }
    },
    handleTriggerPause() {
      this.$refs.player.pause()
    },
    handlePause(event, data) {
      if (debounceApiCall && typeof debounceApiCall.cancel === 'function') {
        debounceApiCall.cancel()
      }
      if (event && event.seconds !== undefined) {
        this.current_time = event.seconds
      }
      this.pause = true
      this.$refs.player.pause()

      let percent =
        event && event.percent !== undefined
          ? event.percent
          : this.last_progress_params
          ? this.last_progress_params.duration / 100
          : 0
      let duration = parseFloat(Number(percent * 100).toFixed(2))
      let activeLesson = this.active_lesson
      if (activeLesson && activeLesson.video) {
        let params = {
          duration: duration,
          course_id: activeLesson.course_id,
          video_id: activeLesson.video.video_id,
          lesson_id: activeLesson.id,
          chapter_id: activeLesson.chapter_id,
          casesafe_id: localStorage.getItem('customer_id'),
          viewed_at: Math.floor(Date.now() / 1000),
          is_complete: duration > 90 ? 1 : 0,
        }
        callLessonProgressApi(params)
        this.last_progress_params = params
        this.has_unsaved_progress = false

        this.$emit('returnProgress', percent, this.active_lesson)
        this.$store.dispatch('updateLessonProgress', params)
      }
    },
    handleEnded(event, data) {
      if (debounceApiCall && typeof debounceApiCall.cancel === 'function') {
        debounceApiCall.cancel()
      }
      let activeLesson = this.active_lesson
      let params = {
        duration: 100,
        // duration: (event.seconds / this.active_lesson.video.duration) * 100,
        course_id: activeLesson.course_id,
        video_id: activeLesson.video.video_id,
        lesson_id: activeLesson.id,
        chapter_id: activeLesson.chapter_id,
        casesafe_id: localStorage.getItem('customer_id'),
        viewed_at: Math.floor(Date.now() / 1000),
        is_complete: 1,
      }
      callLessonProgressApi(params)
      this.last_progress_params = params
      this.has_unsaved_progress = false

      this.$emit('returnProgress', 1, this.active_lesson)
      this.$store.dispatch('updateLessonProgress', params)

      this.$emit('videoEnded', data)
    },
    handleProgress(event, data) {
      // this.$nextTick(() => {
      //   console.log(event, data, 'progresssss')
      //   this.$emit('returnProgress', event.percent, this.active_lesson)
      //   let activeLesson = this.active_lesson
      //   let params = {
      //     duration: parseFloat(Number(event.percent * 100).toFixed(2)),
      //     course_id: activeLesson.course_id,
      //     video_id: activeLesson.video.video_id,
      //     lesson_id: activeLesson.id,
      //     chapter_id: activeLesson.chapter_id,
      //     casesafe_id: localStorage.getItem('customer_id'),
      //     viewed_at: Math.floor(Date.now() / 1000),
      //   }
      //   this.$store.dispatch('updateLessonProgress', params)
      // })
    },
    handleSeeking(event, data) {},
    handleSeeked(event, data) {
      if (event && event.seconds !== undefined) {
        this.current_time = event.seconds
      }
      let percent =
        event && event.percent !== undefined
          ? event.percent
          : this.last_progress_params
          ? this.last_progress_params.duration / 100
          : 0
      let duration = parseFloat(Number(percent * 100).toFixed(2))
      let activeLesson = this.active_lesson
      if (activeLesson && activeLesson.video) {
        let params = {
          duration: duration,
          course_id: activeLesson.course_id,
          video_id: activeLesson.video.video_id,
          lesson_id: activeLesson.id,
          chapter_id: activeLesson.chapter_id,
          casesafe_id: localStorage.getItem('customer_id'),
          viewed_at: Math.floor(Date.now() / 1000),
          is_complete: duration > 90 ? 1 : 0,
        }
        this.last_progress_params = params
        this.has_unsaved_progress = true

        this.$emit('returnProgress', percent, this.active_lesson)
        this.$store.dispatch('updateLessonProgress', params)

        debounceApiCall(params)
      }
    },
  },
}
</script>

<style scoped>
.inner-video-container {
  position: relative;
  width: 100% !important;
  /* padding-top: 56.25% !important; /* 16:9 aspect ratio */
}

.inner-video-container iframe {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  max-width: 100% !important;
}
</style>
